import React from 'react'
import styles from './DashboardDetailsBox.less'
import _ from 'common-tools/LodashHelper'
import { FAIcon } from './FAIcon'
import { ImgURL } from './ImgURL'

export class DashboardDetailsBox extends React.Component {
  static defaultProps = {
    fields: [],
    showPicture: false,
    emptyPictureIcon: 'user',
    boxStyle: 0
  }

  render () {
    const { fields, onClick, picture, emptyPictureIcon, showPicture, boxStyle } = this.props

    let primaryInfo1 = _.find(fields, { type: 'Primary1' })
    let primaryInfo2 = _.find(fields, { type: 'Primary2' })
    let primaryInfo3 = _.filter(fields, { type: 'Primary3' })

    let pictureDiv = null

    if (showPicture) {
      if (picture) {
        pictureDiv = <div className={styles.pictureStyle}><ImgURL src={picture} pictureKey={picture} /></div>
      } else {
        pictureDiv = <div className={styles.assignmentImgEmpty} ><FAIcon name={emptyPictureIcon || 'user'} /></div>
      }
    }

    return (
      <div className={`${styles[`itemBox${boxStyle}`]} ${onClick ? styles.withCursor : ''}`} onClick={onClick}>
        {pictureDiv}
        {primaryInfo1
          ? <div className={styles.textPrimary1}>{primaryInfo1.value}</div>
          : null
        }
        {primaryInfo2
          ? <div className={styles.textPrimary2}>{primaryInfo2.value}</div>
          : null
        }
        {primaryInfo3.length > 0
          ? <div className={styles.textPrimary3}>
            {_.map(primaryInfo3, (info, i) => {
              if (_.isNil(info.value)) {
                return
              }
              if (i > 0) {
                return [
                  <span key={`line_${i}`}>|</span>,
                  <span key={`value_${i}`}>{info.value}</span>
                ]
              } else {
                return <span key={`line_${i}`}>{info.value}</span>
              }
            })}
          </div>
          : null
        }
      </div>
    )
  }
}
